import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../auth/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(protected router: Router, private kc: AuthenticationService) { }

    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {

        const roles = route.data['roles'] as Array<string>;

        if (roles == null) {
             return true;
        }

        let hasRole = false;
        roles.forEach(element => {
            if (this.kc.hasRole(element)) {
                hasRole = true;
            }
        });

        if (hasRole) {
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;

    }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/ubi-core/auth-guard.service.ts